import React from "react";
import { useParams, Link } from "react-router-dom";
import { Breadcrumb } from "semantic-ui-react";

const BreadcrumbsWithParams = () => {
  const { ownerName, projectSlug, recNum } = useParams();
  return (
    <>
      {projectSlug && (
        <>
          <Breadcrumb style={{ marginBottom: "20px" }}>
            <Breadcrumb.Section content="Home" as={Link} to="/" />
            <Breadcrumb.Divider icon="right chevron" />
            <Breadcrumb.Section
              content={`${ownerName} / ${projectSlug}`}
              active={!recNum}
              as={recNum ? Link : "div"}
              to={`/${ownerName}/${projectSlug}`}
            />
            {recNum && (
              <>
                <Breadcrumb.Divider icon="right chevron" />
                <Breadcrumb.Section content={`Recording № ${recNum}`} active />
              </>
            )}
          </Breadcrumb>
          <br />
          <br />
        </>
      )}
    </>
  );
};

export default BreadcrumbsWithParams;
